import { useQuery } from '@hooks/reactQuery';

import { getPortalProjectMembers } from '@api/projectManagement';

import { extractQueryParams } from '@utils/common';
import { projectUsersFormatted } from '@utils/formatter';

import { TNameTitleValueLabel } from '@interfaces/common/common';

import { refetchOptions } from '@constants/common';
import { PORTAL_PROJECTS_MEMBERS } from '@constants/queryKeys';

interface IUseQueryProjectMembersReturned {
	portalProjectsMembers: TNameTitleValueLabel[];
	isLoadingPortalProjectsMembers: boolean;
}

export const useQueryPortalProjectsMembers = (organizationId?: string): IUseQueryProjectMembersReturned => {
	const {
		data: portalProjectsMembers,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [PORTAL_PROJECTS_MEMBERS, { organizationId }],
		queryFn: extractQueryParams(getPortalProjectMembers),
		enabled: [organizationId],
		select: requestTypes => projectUsersFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		portalProjectsMembers: portalProjectsMembers || [],
		isLoadingPortalProjectsMembers: isLoading || isFetching,
	};
};
